const doc = [({"da":({"js":({"user_steps":({"element_types":({"question_file":({"index":({"uploaded_answers":"Uploadede besvarelser"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;